import { ENDPOINTS } from "@/constants/endpoints"
import { QUERY_KEYS } from "@/constants/queryKeys"
import { useGenericQuery } from "@/hooks/useGenericQuery"
import type {
  HomeAbsenceAlert,
  HomeLatestFeedback,
  HomeLecturesDegreesStats,
  HomeMissedTasksAlert,
  HomeProgress,
  HomeRanking,
  HomeStats,
  HomeTopOne,
} from "@/types/homeTypes"

export const useStatsData = () => {
  //✅
  return useGenericQuery<HomeStats[]>({
    keys: QUERY_KEYS.home.stats(),
    apiEndpoint: ENDPOINTS.home.stats(),
  })
}

export const useStudentRankingData = () => {
  //✅
  return useGenericQuery<HomeRanking[]>({
    keys: QUERY_KEYS.home.ranking(),
    apiEndpoint: ENDPOINTS.home.ranking(),
  })
}

export const useStudentProgressData = () => {
  //✅
  return useGenericQuery<HomeProgress[]>({
    keys: QUERY_KEYS.home.progress(),
    apiEndpoint: ENDPOINTS.home.progress(),
  })
}

export const useLecturesDegreesStats = () => {
  //✅
  return useGenericQuery<HomeLecturesDegreesStats>({
    keys: QUERY_KEYS.home.lecturesStats(),
    apiEndpoint: ENDPOINTS.home.lecturesStats(),
  })
}

export const useLatestFeedbackData = () => {
  //✅
  return useGenericQuery<HomeLatestFeedback[]>({
    keys: QUERY_KEYS.home.latestFeedbacks(),
    apiEndpoint: ENDPOINTS.home.latestFeedbacks(),
  })
}

export const useTopOneData = () => {
  //✅
  return useGenericQuery<HomeTopOne>({
    keys: QUERY_KEYS.home.topOne(),
    apiEndpoint: ENDPOINTS.home.topOne(),
  })
}

export const useAbsenceAlertData = () => {
  //✅
  return useGenericQuery<HomeAbsenceAlert>({
    keys: QUERY_KEYS.home.absenceAlert(),
    apiEndpoint: ENDPOINTS.home.absenceAlert(),
  })
}

export const useMissedTasksAlertData = () => {
  //✅
  return useGenericQuery<HomeMissedTasksAlert>({
    keys: QUERY_KEYS.home.missedTasksCheck(),
    apiEndpoint: ENDPOINTS.home.missedTasksCheck(),
  })
}
